export default __webpack_public_path__ + "images/5de127859d4c1c23b1d7f0842e5b71e3.png";